export default __webpack_public_path__ + "static/HeroSectionLeft_es-d452ef8e728ced1eac53fa9e36c47d6c.png";